// extracted by mini-css-extract-plugin
export default {"tab":"Response_tab__U+JbA","header":"Response_header__2xGXz","title":"Response_title__i40LA"};